<template>
  <div>
    <va-card>
      <va-data-table
        :fields="fields"
        :data="florists"
        :loading="loading"
        class="va-table va-table--hoverable va-table--clickable"
        no-data-label="Пусто"
      >
        <template slot="photo" slot-scope="props">
          <div v-if="props.rowData.photo">
            <img
              :src="props.rowData.photo.url"
              class="florist-photo"
              alt="florist-photo"
            />
          </div>
          <div v-else>-</div>
        </template>
        <template slot="name" slot-scope="props">
          <span>{{ props.rowData.name }}</span>
        </template>
        <template slot="experience" slot-scope="props">
          <span>{{ props.rowData.experience || '-' }}</span>
        </template>
        <template slot="short_description" slot-scope="props">
          <span>{{ props.rowData.short_description || '-' }}</span>
        </template>
        <template slot="products_count" slot-scope="props">
          <span>{{ props.rowData.products ? props.rowData.products.length : 0 }}</span>
        </template>
        <template slot="actions" slot-scope="props">
          <va-button
            flat
            small
            color="gray"
            icon="fa fa-pencil"
            @click.stop="updateHandler(props.rowData)"
          />
          <va-button
            flat
            small
            color="gray"
            icon="fa fa-trash"
            @click.stop="removeHandler(props.rowData.id)"
          />
        </template>
      </va-data-table>
    </va-card>
    <va-modal v-model="updateModal" size="large" hide-default-actions>
      <florist-update
        :florist="currentFlorist"
        @close="updateModal = false"
        @updated="handleUpdated"
      />
    </va-modal>
  </div>
</template>

<script>
import api from '@/api/axios';
import FloristUpdate from './florist-update.vue';

export default {
  components: { FloristUpdate },
  props: {
    florists: {
      type: Array,
      require: true,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      updateModal: false,
      currentFlorist: null,
    };
  },
  computed: {
    fields() {
      return [
        {
          name: '__slot:photo',
          title: 'Фото',
          width: '100px',
        },
        {
          name: '__slot:name',
          title: 'Имя',
        },
        {
          name: '__slot:experience',
          title: 'Опыт',
        },
        {
          name: '__slot:short_description',
          title: 'Краткое описание',
        },
        {
          name: '__slot:products_count',
          title: 'Товаров',
          width: '100px',
        },
        {
          name: '__slot:actions',
          title: '',
          width: '100px',
        },
      ];
    },
  },
  methods: {
    updateHandler(florist) {
      this.updateModal = true;
      this.currentFlorist = florist;
    },
    handleUpdated() {
      this.updateModal = false;
      this.$emit('refresh');
    },
    async removeHandler(id) {
      if (confirm('Вы действительно хотите удалить флориста?')) {
        try {
          await api.delete(`/admin/florists/${id}`);
          this.$emit('refresh');
        } catch (error) {
          console.error('Ошибка удаления флориста:', error);
          alert('Ошибка при удалении флориста');
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.florist-photo {
  width: 60px;
  height: 60px;
  object-fit: cover;
  border-radius: 50%;
}
</style>

